import { KYMW6901Component } from "../kymw6901.component";
import { KYMW6901Model } from "../kymw6901.model";
import { MasterInputModel } from "./vo/master-input.model";

export class KYMW6901MasterInputTabModel {
  parent: KYMW6901Component;
  loginUser: { userId: string, associatedUserType: string, userClassList?: { classCode: string; userClass: string; }[]; };

  orderUnitTypeList = [];
  coopMap: { [key: string]: string; };
  masterInput = new MasterInputModel();
  hasChanged = false;
  selectedTabIndex = 0;
  markDivCtp = '';
  disabledSettings = {
    packagePhotoNum: false,
    packageDataNum: false,
    peakPhotoNum: false,
    peakDataNum: false,
    cookingNecessaryPhotoNum: false,
    cookingNecessaryDataNum: false,
    cookingUnnecessaryPhotoNum: false,
    cookingUnnecessaryDataNum: false,
    materialPhotoNum: false,
    materialDataNum: false,
    backsidePhotoNum: false,
    backsideDataNum: false,
  };

  router = null;

  searchParams: any;

  validations = [
    {
      validate: () => {
        const [integer, decimal] = this.masterInput.standardCostPrice.split('.');
        if (!decimal) {
          return integer.length <= 7;
        }
        return integer.length <= 7 && decimal.length <= 2;
      },
      code: 'W0015',
      message: ['希望価格（仕入価）／通常', '7', '2']
    },
    {
      validate: () => {
        const [integer, decimal] = this.masterInput.special1CostPrice.split('.');
        if (!decimal) {
          return integer.length <= 7;
        }
        return integer.length <= 7 && decimal.length <= 2;
      },
      code: 'W0015',
      message: ['希望価格（仕入価）／特１', '7', '2']
    },
    {
      validate: () => {
        const [integer, decimal] = this.masterInput.special2CostPrice.split('.');
        if (!decimal) {
          return integer.length <= 7;
        }
        return integer.length <= 7 && decimal.length <= 2;
      },
      code: 'W0015',
      message: ['希望価格（仕入価）／特２', '7', '2']
    },
    {
      validate: () => {
        const [integer, decimal] = this.masterInput.unitPriceCoefficient.split('.');
        if (!decimal) {
          return integer.length <= 5;
        }
        return integer.length <= 5 && decimal.length <= 2;
      },
      code: 'W0015',
      message: ['ユニットプライス係数', '5', '2']
    },
    {
      validate: () => {
        const [integer, decimal] = this.masterInput.alcoholType.split('.');
        if (!decimal) {
          return integer.length <= 3;
        }
        return integer.length <= 3 && decimal.length <= 2;
      },
      code: 'W0015',
      message: ['アルコール分別', '3', '2']
    },
    {
      validate: () => {
        if (this.masterInput.applyTermStart && this.masterInput.applyTermEnd) {
          return this.masterInput.applyTermStart <= this.masterInput.applyTermEnd;
        } else {
          return true;
        }
      },
      code: 'E0123',
      message: ['取扱期間']
    },
    {
      validate: () => {
        const [integer, decimal] = this.masterInput.fcmcFee.split('.');
        if (!decimal) {
          return integer.length <= 6;
        }
        return integer.length <= 6 && decimal.length <= 2;
      },
      code: 'W0015',
      message: ['FC/MC手数料', '6', '2']
    },
    {
      validate: () => {
        // マークの選択値を取得
        const selectedValeus = this.markDivToList();
        // Setを使用して配列の重複を取り除き、マークの選択値(重複排除前)の長さが一致すれば重複無し。
        // 長さが違えば重複ありとみなす。
        return new Set(selectedValeus).size == selectedValeus.length;
      },
      code: 'E0611',
    },

  ];


  setCoopMap(coopMap: { [key: string]: string; }) {
    this.coopMap = { ...coopMap };
  }
  toCoopMap(coopCodes: string[]) {
    const result = coopCodes.reduce((prev, coop) => {
      const coopName = this.coopMap[coop];
      return {
        ...prev,
        [coopName]: true,
      };
    }, this.masterInput.expandableCoop);
    return result;
  }

  expandableCoopToCoopCodeList() {
    const result = Object.entries(this.masterInput.expandableCoop)
      .filter(([, checked]) => checked)
      .reduce((prev, [coopName]) => {
        const coopCode = Object.keys(this.coopMap).find(key => this.coopMap[key] === coopName);
        if (coopCode) {
          return [...prev, coopCode];
        }
        return prev;
      }, []);

    return result;
  }

  markDivToList() {
    const result = Object.values(this.masterInput.markDiv).filter(markDiv => !!markDiv);
    return result;
  }

  initDisabledSettings() {

    // マスタ入力されたかで全体を制御する
    const numDisabled = !!this.masterInput.masterInputId ? true : false ;
    this.disabledSettings = {
      packagePhotoNum: numDisabled,
      packageDataNum: numDisabled,
      peakPhotoNum: numDisabled,
      peakDataNum: numDisabled,
      cookingNecessaryPhotoNum: numDisabled,
      cookingNecessaryDataNum: numDisabled,
      cookingUnnecessaryPhotoNum: numDisabled,
      cookingUnnecessaryDataNum: numDisabled,
      materialPhotoNum: numDisabled,
      materialDataNum: numDisabled,
      backsidePhotoNum: numDisabled,
      backsideDataNum: numDisabled,
    };
  }

  // 部門を予備に渡す
  getMarkReserve() {

    // 文字内全て半角スペースかチェック
    const isAllHalfSpace: Function = (str: string) => {
      if (str) {
        const halfSpaceMatchArray: Array<string> = str.match(/ /g);
        return halfSpaceMatchArray && halfSpaceMatchArray.length == str.length;
      }
      return false;
    };

    if (!this.masterInput.classCode || isAllHalfSpace(this.masterInput.classCode)) {
      return '';
    }
    return this.masterInput.classCode;
  }

  isClient() {
    return this.loginUser?.associatedUserType === KYMW6901Model.ASSOCIATED_USER_TYPE_SUPPLIER;
  }

  validate() {
    const error = this.validations.find(v => !v.validate());
    if (!error) {
      return null;
    }
    return { code: error.code, message: error.message };
  }

  existsMasterInputValue() {
    const existingValueCounts = Object.entries(this.masterInput)
      .filter(([key]) => key !== 'proposalId')
      .filter(([, value]) => {
        const existsStringValue = (value: unknown) => {
          return typeof value === 'string' && value;
        };
        const existsTrueValue = (value: unknown) => {
          return typeof value === 'boolean' && value;
        };
        const existsArrayItem = (value: unknown) => {
          return value instanceof Array && value.length;
        };
        const existsObjectValue = (value: unknown) => {
          const isObject = value !== null && typeof value === 'object';
          const existingValueCounts = isObject && Object.values(value).filter(value => {
            return existsStringValue(value) || existsTrueValue(value) || existsArrayItem(value);
          }).length;
          return existingValueCounts ? true : false;
        };
        return existsStringValue(value) || existsTrueValue(value) || existsArrayItem(value) || existsObjectValue(value);
      }).length;

    return existingValueCounts ? true : false;
  }
}